@if (vm$ | async; as vm) {
    <ms-fixture-list-header [sport]="vm.sport" [competitionTitle]="vm.title" [showFavoriteToggle]="vm.isFavouritesEnabled">
        @if (vm.virtualCompetition) {
            <ms-tournament-groups [model]="vm.virtualCompetition" />
        }
    </ms-fixture-list-header>
}
